import { forwardRef } from 'react';

//npm imports
import styled, { withTheme } from 'styled-components/macro';
import useArrayLength from '../../Hooks/useArrayLength';

//component imports
import { Caption12 } from '../Text/Text';

const InputFieldWrapper = styled.div`
    width: 100%;
    .label{
        margin-bottom: 11px;
    }
    .error{
        height: 14px;
        margin-top: 8px;
    }
`

const InputContainer = styled.aside`
    width: 100%;
`

const Input = styled.input`
    width: 100%;
    height: 58px;
    padding-left: 24px;
    font-family: 'Raleway', sans-serif;
    font-size: ${props => props.theme.text16}px;
    line-height: ${props => props.theme.text16LineHeight}px;
    font-weight: 400;
    color: ${props => props.errors?.length > 0 ? props.theme.textError : props.val !== "" ? props.theme.violet : props.theme.gray1};
    border-radius: 4px;
    border: 1.5px solid ${props => props.errors?.length > 0 ? props.theme.textError : props.val !== "" ? props.theme.violet : "transparent"};
    background-color: ${props => props.inputBackground ? props.inputBackground : props.theme.black2};
    outline: none;
    &:focus, &:active, &:target{
        outline: none;
    }

    &:hover{
        border: 1.5px solid ${props => props.theme.gray1};
        color: ${props => props.theme.gray1}
    }
    
    &:hover::placeholder{
        color: ${props => props.theme.gray1};
    }
    &:focus{
        color: ${props => props.theme.white};
        border: 1.5px solid ${props => props.theme.white};
    }
    @media (max-width: 550px){
        padding-left: 12px;
    }

`

const InputField = forwardRef(({
    type, required, placeholder, disabled, autocomplete, borderColor, value, defaultValue, name, onChange, label, errors, theme, className, placeholderColor, inputBackground, labelColor
}, ref) => {
    return (
        <InputFieldWrapper className={className}>
            <Caption12 className="label" color={labelColor || theme.gray2}>{label}<span>{required && "*"}</span></Caption12>
            <InputContainer>
                <Input
                    errors={errors}
                    type={type}
                    ref={ref}
                    placeholder={placeholder}
                    disabled={disabled}
                    name={name && name}
                    onChange={onChange}
                    defaultValue={defaultValue}
                    val={value}
                    borderColor={borderColor}
                    autocomplete={autocomplete}
                    placeholderColor={placeholderColor}
                    inputBackground={inputBackground}
                />
            </InputContainer>
            <Caption12 className="error" color={theme.textError}>{useArrayLength(errors) && errors.map((error, index) => (<span key={index}><span>{error}</span><br /></span>))}</Caption12>
        </InputFieldWrapper>
    )
})

export default withTheme(InputField);